import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="back-to-top"
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-emerald-700 dark:bg-emerald-600 text-white shadow-lg hover:bg-emerald-800 dark:hover:bg-emerald-700 transition-all hover:scale-110 flex items-center justify-center animate-fade-in"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default BackToTop;
